const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.88,12c0,.84-1.83,1.47-2.01,2.25s1.19,2.17.84,2.9-2.28.51-2.79,1.15.14,2.46-.51,2.98-2.27-.53-3.02-.17-.93,2.28-1.75,2.46-1.8-1.46-2.64-1.46-1.86,1.64-2.64,1.46-1.01-2.11-1.75-2.46-2.38.68-3.02.17,0-2.34-.51-2.98-2.43-.41-2.79-1.15,1.02-2.09.84-2.9S.12,12.84.12,12s1.83-1.47,2.01-2.25-1.19-2.17-.84-2.9,2.28-.51,2.79-1.15-.14-2.46.51-2.98,2.27.53,3.02.17.93-2.28,1.75-2.46,1.8,1.46,2.64,1.46,1.86-1.64,2.64-1.46,1.01,2.11,1.75,2.46,2.38-.68,3.02-.17,0,2.34.51,2.98,2.43.41,2.79,1.15-1.02,2.09-.84,2.9,2.01,1.41,2.01,2.25ZM3.77,7.68v8.76h1.7v-3.67h1.78v3.67h1.7V7.68h-1.7v3.51h-1.78v-3.51h-1.7ZM12.92,7.58c-1.94,0-2.89,2.07-2.89,4.46s.78,4.51,2.77,4.51c1.66,0,2.83-1.34,2.83-4.64,0-2-.6-4.33-2.72-4.33ZM12.86,9.06c.77,0,1,1.39,1,2.93,0,1.78-.27,3.08-.99,3.08s-1.07-1.01-1.07-3c0-1.88.38-3,1.05-3ZM17.58,16.45h1.7v-7.19h1.56v-1.57h-4.81v1.57h1.55v7.19Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.563c973f3d3eac194652e0dd48357430.svg";
export { ForwardRef as ReactComponent };